import LaunchSection from "./launch/launch";
import WhyChooseSurveysiq from "./whychoose/whychoose";
import HowItWorks from "./HowItWorks/howitworks";
import SecureReliable from "./Secure/secure";
import Insight from "./Insight/Insight";
import ContactForm from "./contact/contact";

const Brand = () => {
  return (
    <>
      <LaunchSection />
      <WhyChooseSurveysiq />
      <HowItWorks />
      <ContactForm />
      <SecureReliable />
      <Insight />
    </>
  );
};
export default Brand;
